import React from 'react';
import { Navigate, useParams, useLocation } from 'react-router-dom';
import jwtDecode from 'jwt-decode';
import { sessionRole } from './accountScope';

const PrivateRoute = ({ component: Component, roles, ...rest }) => {
  const token = localStorage.getItem('access_token');
  const { conversationId } = useParams();
  const location = useLocation();

  if (!token) {
    return <Navigate to="/" replace />;
  }

  let decodedToken;
  try {
    decodedToken = jwtDecode(token);
  } catch (error) {
    console.error('Invalid token:', error);
    localStorage.removeItem('access_token');
    return <Navigate to="/" replace />;
  }

  const userRole = decodedToken.role;

  // A logistics user outside its allowed pages lands on the archive (the old
  // landing, /returns, was a removed e-commerce page — 2026-10-28).
  if (userRole === 'logistics' && 
      !location.pathname.startsWith('/parameters') && 
      !location.pathname.startsWith('/logistics-ai-assistants') && 
      !location.pathname.startsWith('/conversation') &&
      !location.pathname.startsWith('/order-logistics')&&
      !location.pathname.startsWith('/dashboard-logs')&&
      !location.pathname.startsWith('/tickets/archive')&&
      !/^\/tickets\/[^/]+\/messages/.test(location.pathname) &&
      !location.pathname.startsWith('/logistics-statistics') &&
      !location.pathname.startsWith('/employee-productivity') &&
      !location.pathname.startsWith('/parcel-monitor') &&
      !location.pathname.startsWith('/commerce/orders') &&
      !location.pathname.startsWith('/sms-notifications') &&
      !location.pathname.startsWith('/shops') &&
      !location.pathname.startsWith('/create-agent')) {
    return <Navigate to="/tickets/archive" replace />;
  }

  // For other roles, check if they have access to the current route
  if (roles && !roles.includes(userRole)) {
    // Redirect admin and employee to dashboard, logistics to returns
    const redirectPath = userRole === 'logistics' ? '/tickets/archive' : '/dashboard';
    return <Navigate to={redirectPath} replace />;
  }

  return <Component {...rest} conversationId={conversationId} isAuthenticated={true} userRole={userRole} />;
};

// Role gate of one page. react-router v6 ignores a `roles` prop on <Route>:
// until 29/10 the lists in App.js were never read and any signed-in role
// could open any page by its URL. The backend still checks every call; this
// keeps people out of pages that are not theirs (Kevin 29/10: an employee
// only has « Mon compte » for settings).
export const RequireRole = ({ roles, children }) => {
  const role = sessionRole();
  if (roles && !roles.includes(role)) {
    return <Navigate to={role === 'logistics' ? '/tickets/archive' : '/dashboard'} replace />;
  }
  return children;
};

export default PrivateRoute;
